export function getProxyUrl(url?: string): string {
    if (!url) return '';
    const base = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}/api`;
    return `${base}/proxy/image?url=${encodeURIComponent(url)}`;
}
